import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLang from './en/translation.json';
import deLang from './de/translation.json';

void i18n.use(initReactI18next).init({
  resources: {
    ENG: { translation: enLang },
    DE: { translation: deLang },
  },
  lng: 'ENG',
  fallbackLng: 'ENG',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
